'use client';

import { Check, Copy } from 'lucide-react';

import { useCallback, useState } from 'react';

import { copyToClipboard } from '@/shared/utils/text';

import { MCP_SERVER_URL } from '../../constants/mcp-content';
import {
	SECTION_CLASS,
	SECTION_HEADING_CLASS,
	SECTION_LEAD_CLASS,
} from '../../constants/section-classes';

export const McpHowToConnectSection = () => {
	const [copied, setCopied] = useState(false);

	const handleCopy = useCallback(() => {
		copyToClipboard({ text: MCP_SERVER_URL });
		setCopied(true);
		window.setTimeout(() => setCopied(false), 2000);
	}, []);

	return (
		<section className={SECTION_CLASS}>
			<div className="mx-auto flex max-w-3xl flex-col items-center">
				<h2 className={SECTION_HEADING_CLASS}>How to connect?</h2>
				<p className={SECTION_LEAD_CLASS}>
					Ask your AI agent to connect to Binary&apos;s MCP server with the URL below.
				</p>
				<button
					type="button"
					onClick={handleCopy}
					aria-label="Copy server URL"
					className="mt-8 flex w-full max-w-xl items-center gap-3 rounded-xl border border-border bg-background px-4 py-3 text-left transition-colors hover:bg-accent md:mt-10"
				>
					<span className="min-w-0 flex-1 break-all font-mono text-sm text-primary md:text-base">
						{MCP_SERVER_URL}
					</span>
					{copied ? (
						<Check className="size-4 shrink-0 text-primary" />
					) : (
						<Copy className="size-4 shrink-0 text-secondary" />
					)}
				</button>
			</div>
		</section>
	);
};
